<template>
  <div class="ReplyForm">
    <form @submit="handleSubmit" enctype="multipart/form-data">
      <div class="form-group">
        <label for="message">
          Message
          <span class="text-danger">*</span>
        </label>
        <vue-editor v-model="message" :editorToolbar="editorToolbar"></vue-editor>
        <div class="text-danger text-xs" v-show="$v.message.$error">
          <span v-if="!$v.message.required">Message is required.</span>
          <span v-if="!$v.message.minLength">Message must be at least {{ $v.message.$params.minLength.min }} letters.</span>
        </div>
      </div>
      <div class="form-group">
        <i class="fa fa-paperclip"></i> Attachment
        <input type="file" ref="file" multiple="multiple" />
        <p class="help-block"><b>File Type:</b> jpg,jpeg,png,gif,pdf,doc,docx,xls,xlsx | <b>Max file size:</b> 5MB</p>
      </div>

      <button class="btn btn-danger btn-lg" type="submit">
        <i class="far fa-paper-plane mr-1"></i>
        Reply
      </button>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import { VueEditor } from "vue2-editor";
import { required, minLength } from "vuelidate/lib/validators";

export default {
  name: "ReplyForm",

  data() {
    return {
      message: "",
      editorToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
      ],
    };
  },

  props: {
    userEmail: String,
    ticketRef: String,
  },

  methods: {
    handleSubmit(e) {
      e.preventDefault();
      let loading = this.$loading.show();
      this.$v.$touch();
      if (this.$v.$invalid) {
        loading.hide();
        return;
      }

      let formData = new FormData();
      let allowedExtensions = ["jpg", "jpeg", "png", "gif", "pdf", "doc", "docx", "xls", "xlsx"];

      for (var i = 0; i < this.$refs.file.files.length; i++) {
        let file = this.$refs.file.files[i];
        formData.append("files[" + i + "]", file);
        // Form Validate ...
        let fileName = file.name;
        let fileExtension = fileName.replace(/^.*\./, "");
        if (allowedExtensions.includes(fileExtension) == false) {
          let msg = "." + fileExtension + " file not allowed. Please replace " + file.name;
          this.$swal("Oops!", msg, "error");
          loading.hide();
          return;
        }
        if (file.size > 5000000) {
          let msg = file.name + " is larger than the allowed file size of 5MB.";
          this.$swal("Oops!", msg, "error");
          loading.hide();
          return;
        }
      }

      formData.append("ticketID", this.ticketRef);
      formData.append("message", this.message);
      formData.append("email", this.userEmail);
      formData.append("originURL", window.location.origin);

      let path = this.$store.state.authToken == "" ? "/ticket/reply" : "/user/ticket/reply";
      axios
        .post(path, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          if (res.data.status == "success") {
            this.$v.$reset(); //empty form
            this.message = ""; // fee back
            //this.ticket.threads.push(res.data.replies);
            this.$emit("newThread", res.data.replies);
            this.$swal("Done!", res.data.message, "success");
          } else {
            this.$swal("Oops!", res.data.message, "error");
          }
          loading.hide();
        })
        .catch((err) => {
          loading.hide();
        });
    },
  },

  validations: {
    message: { required, minLength: minLength(10) },
  },

  components: {
    VueEditor,
  },
};
</script>